// 产品介绍
<template>
  <div class="cpjs width1200">
    <div class="item-desc">
      <p class="text1">资源组成</p>
      <p class="text2">IP资源来源于全国各地的真实家宽用户。</p>
    </div>
    <!--<div class="item-desc">
      <p class="text1">与传统代理IP池的区别</p>
      <p class="text2">
        传统
        IP代理池：在地区所在机房接入对应数量的拨号线路，在软路由上多拨。一台边点设备对应多条同地区的拨号线路。通常这种拨号线路多为运营商单独划分的代理线路。这些代理线路对应的
        IP池污染程度极高，经常会被反爬程度高的目标站点风控。
      </p>
      <p class="text2">
        家庭住宅
        IP代理池：单一的出口IP对应一台设备（路由器、机顶盒、pad等），用户利用家庭空闲带宽跑边缘计算收取佣金。对应的是运营商的家用IP池，IP为真人家用IP。
      </p>
    </div>-->
    <img
      :src="require('@/assets/images/cpjs14.jpg')"
      alt=""
      class="cpjs-imgs w-100"
    />
    <div class="item-desc">
      <p class="text1">使用方式</p>
      <p class="text2">
        用户使用 API提取的方式，获取到分布式中心代理服务器的 IP
        以及代理端口。一个代理端口对应一个出口 IP。
      </p>
    </div>
    <div class="item-desc">
      <p class="text1">支持的协议</p>
      <p class="text2">HTTP、SOCKS5</p>
    </div>
    <div class="item-desc">
      <p class="text1">计费方式</p>
      <p class="text2">按 IP 提取量，提取了就开始计费。</p>
    </div>
    <div class="item-desc">
      <p class="text1">套餐介绍</p>
      <ul>
        <li>
          不限制单次提取量，但是单次提取的最大值为购买的线路数（并发数）。代理端口使用时长要满足 15 分钟以上。
        </li>
        <li>提取到的代理端口需要手动释放，释放时间受 15 分钟使用时长限制。释放可全部释放或者部分释放。释放完端口后，才能重新提取新的端口。如果不释放会一直有效。</li>
        <li>使用过程中如果有线路失败或者切换的需求，可以调用切换接口对线路进行切换。每次切换最多只能切换两条线路。切换线路不改变代理端口，只改变出口 IP。切换过程中不指定地区，优先同城切换线路。</li>
        <li>单条线路带宽 2Mbps 左右。</li>
        <li>单条线路不限制并发，实际并发受边缘节点设备影响。</li>
        <li>线路的稳定时长，受边缘节点设备的影响。</li>
        <li>线路出口 IP 的切换受设备所在地的网络运营商策略约束。通常是1-3 天切换一次IP。</li>
        <li>独享线路，共享 IP 池。</li>
        <li>优先去重，不支持主动去重。</li>
        <li>支持企业定制化需求。</li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">验证方式</p>
      <ul>
        <li>提取时采用账密验证，通过验证才能正常调用接口。</li>
        <li>
          提取到分布式中心代理服务器的 IP以及代理端口，使用代理时采用
          IP白名单或者账密验证方式。
        </li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">功能接口</p>
      <ul>
        <li>提取接口：不限制提取数量，可指定地区提取。</li>
        <li>查询在用代理端口接口：查询当前账号已提取使用的代理端口。</li>
        <li>释放接口：释放已提取的代理端口，支持全部或者部分。</li>
        <li>
          切换接口：对已提取的代理端口进行线路切换。一次最多只能切换两个。
        </li>
        <li>查看 IP白名单接口：查看当前账号的 IP 白名单情况。</li>
        <li>
          添加 IP白名单接口：添加 IP白名单。一次可以提交多个 IP，马上生效。
        </li>
        <li>
          删除 IP白名单接口：删除 IP白名单。一次可以提交多个 IP，马上生效。
        </li>
        <li>查看 IP白名单接口：查看当前账号的 IP 白名单情况。</li>
        <li>
          添加 IP 白名单接口：添加 IP 白名单，一次只能提交一个
          IP。分布式机房，生效需要等待几分钟。
        </li>
        <li>
          删除 IP 白名单接口：删除 IP 白名单，一次只能提交一个
          IP。分布式机房，生效需要等待几分钟
        </li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">适用场景</p>
      <dl class="d-flex">
        <dd>
          <img :src="require('@/assets/images/cpjs15.png')" alt="" />
          <span>数据采集</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs18.png')" alt="" />
          <span>游戏挂机</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs17.png')" alt="" />
          <span>广告投放和营销</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs19.png')" alt="" />
          <span>跨境电商</span>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
};
</script>

<style lang="less" scoped>
.cpjs {
  padding: 50px 0 116px;
  .item-desc {
    margin-bottom: 30px;
    p {
      color: #000;
      &.text1 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 6px;
      }
      &.text2 {
        font-size: 18px;
      }
    }
    ul {
      margin-left: 20px;
      li {
        list-style: disc;
        &::marker {
          color: #27a7e7;
          font-size: 24px;
        }
      }
    }
    dl {
      margin-top: 20px;
      dd {
        margin-right: 76px;
        img {
          margin-right: 10px;
        }
      }
    }
  }
  .cpjs-imgs {
    margin: 0 0 30px;
  }
}
@media (max-width: 768px) {
  .cpjs {
    padding: 4% 0;
  }
  .cpjs .item-desc {
    margin-bottom: 2%;
  }
  .cpjs .item-desc p.text1,
  .cpjs .item-desc ul li::marker {
    font-size: 16px;
  }
  .cpjs .item-desc p.text2,
  .cpjs .item-desc ul li {
    font-size: 14px;
  }
  .cpjs .item-desc dl {
    flex-wrap: wrap;
  }
  .cpjs .item-desc dl dd {
    font-size: 14px;
    margin-right: 0;
    width: 50%;
  }
}
@media (max-width: 375px) {
  .cpjs .item-desc dl dd {
    width: 100%;
  }
}
</style>
